export const isEmail = (value: string): boolean => {
  const REGEX = /^([a-zA-Z0-9._-]+)@([a-zA-Z0-9_-]+)\.([a-zA-Z]{2,5})$/
  return REGEX.test(value)
}

export const hasDuplicateEmails = (emails: string[]): boolean => {
  const normalized = emails.map((email) => email.trim().toLowerCase())
  return new Set(normalized).size !== normalized.length
}

export const isPhone = (value: string): boolean => {
  const REGEX = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
  return REGEX.test(value)
}

export const formatWeight = (weight: number, unit: string, locale = 'en-US') => {
  const hasDecimalValue = weight % 1 !== 0
  const formatter = new Intl.NumberFormat(locale, {
    maximumFractionDigits: hasDecimalValue ? 2 : 0,
    minimumFractionDigits: hasDecimalValue ? 1 : 0,
    style: 'decimal',
    useGrouping: true // Enable comma separators for every thousand
  })

  return `${formatter.format(weight)} ${unit}`
}

export const currencyFormatter = (value: string, decimal: number): string => {
  return parseFloat(parseFloat(value).toFixed(decimal)).toLocaleString('en-US')
}

export const formatDistance = (distance: string | number, unit: string, locale = 'en-US') => {
  const distanceNum = typeof distance === 'string' ? parseFloat(distance) : distance
  const hasDecimalValue = distanceNum % 1 !== 0
  const formatter = new Intl.NumberFormat(locale, {
    maximumFractionDigits: hasDecimalValue ? 2 : 0,
    minimumFractionDigits: hasDecimalValue ? 1 : 0,
    style: 'decimal',
    useGrouping: true // Enable comma separators for every thousand
  })

  return `${formatter.format(distanceNum)} ${unit}`
}

/**
 * Format a number as currency
 * @param value The value to format
 * @param currency The currency code (defaults to USD)
 * @returns Formatted currency string
 */
export const formatCurrency = (value: string | number | undefined | null, currency = 'USD'): string => {
  if (value === undefined || value === null) return '--'

  return new Intl.NumberFormat('en-US', {
    currency,
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    style: 'currency'
  }).format(Number(value))
}

export const formatTemperature = (params: {
  max: number | null
  min: number | null
  runType: string | null
  unit: string | null
}) => {
  const { max, min, unit = 'F', runType } = params

  if (max === null && min === null) {
    return null
  }

  if (max === null && min) {
    return `${parseFloat(min.toString())}° ${unit || 'F'}${runType && runType !== 'false' ? ' ' + runType : ''}`
  }

  if (min === null && max) {
    return `${parseFloat(max.toString())}° ${unit || 'F'}${runType && runType !== 'false' ? ' ' + runType : ''}`
  }

  if (max === min && max && min) {
    return `${parseFloat(max.toString())}° ${unit || 'F'}${runType && runType !== 'false' ? ' ' + runType : ''}`
  }

  if (max && min) {
    return `${parseFloat(min.toString())}° to ${parseFloat(max.toString())}° ${unit || 'F'}${
      runType && runType !== 'false' ? ' ' + runType : ''
    }`
  }
}
